// 所有表格行相同的配置
const columnPublicConfig = {
    align: 'center'
}

// 筛选器配置
const filterItemsConfig = {
    scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon'
    }
}

// 编辑内容配置
export const formModel = {
    // username: '',
    // password: ''
}

// 表格配置
/**
 * title: 表格标题
 * dataIndex: 后端返回的这个标题的名字
 * filterIndex: 筛选器字段，一般和dataIndex一样，如果是选择型的筛选器，这里填写id字段
 * key: 随便选择dataIndex或filterIndex中的一个
 * type: 筛选器类型，input = 输入框，select = 选择框
 * multi: 如果选择型筛选器需要多选，就写上值为true
 * items: 选择型筛选器必须带上这个，默认为空数组
 */
export const columns = [{
    title: '名称',
    dataIndex: 'name',
    filterIndex: 'name',
    key: 'name',
    type: 'input',
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '订单号码',
    dataIndex: 'number',
    filterIndex: 'number',
    key: 'number',
    type: 'input',
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '操作记录',
    dataIndex: 'operation',
    // filterIndex: 'operation',
    key: 'operation',
    // type: 'select',
    ...columnPublicConfig,
    // ...filterItemsConfig
},
{
    title: '操作时间',
    dataIndex: 'created_at',
    key: 'created_at',
    ...columnPublicConfig
}]
